@if (dataContent) {
<div class="container">
  <div class="row">
    <div class="col-12">
      <h2>
        {{sesion.nameSession}}, queremos conocerte mejor, completa la siguiente información.
      </h2>
      <p class="sub-title">
        Ten en cuenta que esta quedará registrada en la aplicación con el aliado.
      </p>
    </div>
    <div class="col-12">
      <div>
        <p class="mb-0 mt-2">¿Qué monto necesitas?</p>
        <input type="text" class="input" placeholder="$0 COP" (input)="textInputNum($event.target)">
      </div>
      @if (!correctAmount && amountRequired != '') {
      <div>
        <p class="error">El monto propuesto se encuentra fuera del rango establecido por la entidad</p>
      </div>
      }
    </div>
    <div class="col-12">
      <div>
        <p class="mb-0 mt-2">Estado/situación laboral</p>
        <div class="custom-radio box-check-">
          <button (click)="checkInput($event.target)"
            value="{{actividades_economicas[1].tipo}}">{{actividades_economicas[1].texto}}</button>
          <button (click)="checkInput($event.target)"
            value="{{actividades_economicas[2].tipo}}">{{actividades_economicas[2].texto}}</button>
          <button (click)="checkInput($event.target)"
            value="{{actividades_economicas[4].tipo}}">{{actividades_economicas[4].texto_Alt}}</button>
        </div>
      </div>
    </div>
    <div class="col-12 text-center">
      <button class="cta" [disabled]="!checkData()" (click)="activeResult()">Actualizar y continuar<i
          class="fa fa-chevron-right" aria-hidden="true"></i></button>
      <button class="cta secondary" (click)="this.load.closeBcConecta()">Cancelar<i class="fa fa-chevron-right"
          aria-hidden="true"></i></button>
    </div>
  </div>
</div>
}
@if (resultContent) {
<div class="container">
  <div class="row">
    <div class="col-12">
      @if (success) {
      <h2 class="success">
        ¡Felicitaciones, {{sesion.nameSession}}!
      </h2>
      }
      @if (!success) {
      <h2 class="error">
        ¡Lo sentimos!
      </h2>
      }
      @if (success) {
      <p class="sub-title">
        Ya tienes tu <b>{{offer.offerSelected.card.productName}} {{textAprroved}}</b>.
        <br />
        <br />
        Para recibir el DESEMBOLSO debes completar la solicitud en la pagina web de
        <b>{{offer.offerSelected.company.name}}</b>.
      </p>
      }
      @if (!success) {
      <p class="sub-title">
        No fue posible continuar con tu solicitud debido a las políticas crediticias de
        <b>{{offer.offerSelected.company.name}}.</b>
      </p>
      }
      @if (!success) {
      <p class="sub-title">
        Te invitamos a conocer más ofertas disponibles para ti.
      </p>
      }
    </div>
    @if (offer.offerSelected.detail.additionalBenefits && success) {
    <div class="col-12">
      <div class="add-benefit">
        <img title="crown" class="crown" alt="corona-beneficio" src="assets/icons/Icono_corona_adicional.svg" />
        <div class="box-benefit">
          <p class="descBenefit">{{offer.offerSelected.detail.textAdditionalBenefits}}</p>
        </div>
      </div>
    </div>
    }
    @if (success) {
    <div class="col-12 text-center">
      <button class="cta" (click)="goAllie()">Ir al desembolso<i class="fa fa-chevron-right"
          aria-hidden="true"></i></button>
    </div>
    }
    @if (!success) {
    <div class="col-12 text-center">
      <button class="cta" (click)="load.closeBcConecta()">Conocer más ofertas<i class="fa fa-chevron-right"
          aria-hidden="true"></i></button>
    </div>
    }
  </div>
</div>
}